<div class="container">
    <div class="jumbotron">
        <img src="assets/images/cop4all_90p.png" alt="Cop4ALL NRW Logo">
        <p></p>
        <h3 class="display-5">Copernicus für ALKIS und Landbedeckung NRW</h3>
        <p class="lead">Aktuell werden Wartungsarbeiten durchgeführt, sodass eine Nutzung erst zu einem späteren
            Zeitpunkt möglich ist.</p>
        <hr class="my-4">
        <p>Das Projekt „Copernicus für ALKIS und Landbedeckung NRW“ behandelt die praktische Inwertsetzung von
            Copernicus-Daten für das Land und die Katasterbehörden in Nordrhein-Westfalen in Form der Bereitstellung von
            Veränderungsinformationen sowie der Erstableitung der Landbedeckung.</p>
    </div>
</div>
